module.exports = __webpack_public_path__ + "VIPV32.png?852383aa081341d16ed817746155add2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV32.png
// module id = 128
// module chunks = 0